var map = {
	"./3DConnect4/3DC4.1.png": 4036,
	"./3DConnect4/3DC4.2.png": 1386,
	"./3DConnect4/3DC4.3.png": 9348,
	"./PricesTracker/PricesTracker.1.png": 3461,
	"./PricesTracker/PricesTracker.2.png": 5990,
	"./PricesTracker/PricesTracker.4.png": 3624,
	"./Santorini/Santorini.1.png": 6946,
	"./Santorini/Santorini.2.png": 8379,
	"./Santorini/Santorini.3.png": 1714,
	"./Santorini/Santorini.4.png": 5633,
	"./Santorini/Santorini.5.png": 944,
	"./Santorini/Santorini.6.png": 4788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1937;